// 정산(회원별) 테이블의 '남은 수업수' 옆에 붙는 수강권 상태 배지.
// remainSession 은 조회 월 말 기준 잔여(만료 수강권도 그 달 시점 값)이고, 배지는 현재 상태를 보여준다.
export type SettlementMembershipBadge = {
  label: string;
  bg: string;
  color: string;
};

type SettlementRowLike = {
  membershipStatus?: string | null;
  isCanceled?: boolean | null;
};

const CANCELED_BADGE: SettlementMembershipBadge = {
  label: "취소",
  bg: "#FEF2F2",
  color: "#991B1B",
};
const EXPIRED_BADGE: SettlementMembershipBadge = {
  label: "만료",
  bg: "#F3F4F6",
  color: "#6B7280",
};

export const resolveSettlementMembershipBadge = (
  row: SettlementRowLike | null | undefined,
): SettlementMembershipBadge | null => {
  if (!row) return null;
  if (row.isCanceled === true) return CANCELED_BADGE;
  const status = String(row.membershipStatus ?? "").toLowerCase();
  // 필드가 없는 구버전 응답은 배지를 그리지 않는다.
  if (!status || status === "active") return null;
  return EXPIRED_BADGE;
};

export const resolveSettlementMembershipStatusText = (
  row: SettlementRowLike | null | undefined,
): string => resolveSettlementMembershipBadge(row)?.label ?? "활성";
